import React from 'react';
import { useSelector, useDispatch } from "react-redux";
import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import RefreshIcon from '@mui/icons-material/Refresh';

const ActionButtons = () => {
    const find = () => {
        console.log(window);
        window.findChannel();
    };
    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <IconButton sx={{ color: 'white' }} onClick={() => find()}>
                <ArrowBackIcon />
            </IconButton>
            <IconButton sx={{ color: 'white' }} onClick={() => window.handleRefresh()}>
                <RefreshIcon />
            </IconButton>
            <IconButton sx={{ color: 'white' }} onClick={() => window.handleForward()}>
                <ArrowForwardIcon />
            </IconButton>
        </div>
    );
};

export default ActionButtons;
